<template>
	<div class="mx-auto w-full" :class="cn('', props.class)">
		<div class="mx-auto w-full" :class="cn('', mainClass)">
			<slot />
		</div>
	</div>
</template>
<script setup lang="ts">
import type { HTMLAttributes } from 'vue';

import { cn } from '@/utils';

const props = defineProps<{
	class?: HTMLAttributes['class'];
	mainClass?: HTMLAttributes['class'];
}>();
</script>
